/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-unused-state */
/* eslint-disable arrow-spacing */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { fetchLeaseWorkorders, fetchCategories, clearCreateAction, fetchWorkOrderSchema } from '../redux/actions';
import SectionHeader from '../../../components/sectionHeader';
import Clickable from '../../../components/clickable/Clickable';
import Button from '../../../components/button/button';
import Paginator from '../../../components/paginator/paginator';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';
import styles from '../inspections.module.scss';
import styles2 from '../../PermitManagement/ADP/Logs/logs.module.scss';
import styles1 from '../../PermitManagement/ADP/Logs/Filter.module.scss';
import FilterForm from '../../PermitManagement/components/filterForm/FilterForm';
import Table from './components/Table';
import { getDatesFromRange } from '../../../utils/helpers';
import { fetchUserProfile } from '../../authentication/redux/actions';

class MaintenanceList extends Component {
  state = {
    range: {},
    new_wo: 0,
    inProgress: 0,
    completed: 0,
    currentPage: 1,
    searchQuery: '',
    c: [],
    workorders: [],
    popup: false,
    activeTab: 'open',
    init: true,
    filter: (localStorage.getItem('lease_maintenance_filters')
    ? JSON.parse(localStorage.getItem('lease_maintenance_filters'))
      : []),
    filterCategories: [
      {
       id: 0,
       name: 'without_collapse',
       permissions: [{ id: 0, title: 'Created By Me' }]
     }]
  }

  slideStyles = {
    entered: { transform: 'translate3d(0px,0px)' }
  };

  componentDidMount() {
    const { actionFetchWorkOrders, actionFetchCategories, actionFetchUser, actionFetchSchema } = this.props;
    actionFetchUser();
    actionFetchSchema();
    const storedRange = localStorage.getItem('lease_maintenance_range');
    const filters = localStorage.getItem('lease_maintenance_filters');
    let s; let f;
    if (storedRange) {
      [s, f] = getDatesFromRange(storedRange);
      s = s.toISOString();
      f = f.toISOString();
    } else {
      s = localStorage.getItem('lease_maintenance_start_date');
      f = localStorage.getItem('lease_maintenance_end_date');
      if (s && f) {
        s = new Date(s);
        f = new Date(f);
      } else {
        s = new Date();
        s.setDate(s.getDate() - 30);
        f = new Date();
        localStorage.setItem('lease_maintenance_range', 'Last 30 days');
      }
      s.setHours(0, 0, 0, 0);
      f.setHours(23, 59, 59, 99);
      s = s.toISOString();
      f = f.toISOString();
    }
    if (filters) {
      actionFetchWorkOrders(filters?.includes('Created By Me'));
    } else {
      actionFetchWorkOrders(1, s, f);
    }
    actionFetchCategories();
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.workorders.length > 0 && props.allWorkOrders && props.allWorkOrders && props.allWorkOrders.length && state.init === true) {
      if (props?.user?.portal_airport?.airport_settings?.enable_service_request === true) {
        const new_wo = props.allWorkOrders.filter(workorder => workorder.status === 'New'
          || workorder.status === 'Approved'
          || workorder.status === 'Duplicate');
        const sortWorkorders = _.orderBy(new_wo, 'report_date', 'desc');

        return {
          ...state,
          workorders: sortWorkorders,
          new_wo: new_wo.length,
          inProgress: 0,
          completed: 0,
          init: false
        };
      }
      const new_wo = props.allWorkOrders.filter(workorder => workorder.status === 0 || workorder.status === 7);
      const inProgress = props.allWorkOrders.filter(workorder => workorder.status === 1 || workorder.status === 4
        || workorder.status === 5 || workorder.status === 6 || workorder.status === 8 || workorder.status === 9
        || workorder.status === 12);
      const completed = props.allWorkOrders.filter(workorder => workorder.status === 2);
      const activeWorkorders = new_wo.concat(inProgress);
      const sortWorkorders = _.orderBy(activeWorkorders, 'report_date', 'desc');

      return {
        ...state,
        workorders: sortWorkorders,
        new_wo: new_wo.length,
        inProgress: inProgress.length,
        completed: completed.length,
        init: false
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { allWorkOrders, actionClear, createWorkorderAction, user } = this.props;
    if ((prevProps.allWorkOrders && prevProps.allWorkOrders.length) !== (allWorkOrders && allWorkOrders.length)) {
      if (user?.portal_airport?.airport_settings?.enable_service_request === true) {
        const new_wo = allWorkOrders.filter(e => e.status === 'New'
          || e.status === 'Approved'
          || e.status === 'Duplicate');
        const sortWorkorders = _.orderBy(new_wo, 'report_date', 'desc');
        this.setState({
          workorders: sortWorkorders,
          new_wo: new_wo.length,
          inProgress: 0,
          completed: 0
        });
      } else {
        const new_wo = allWorkOrders.filter(e => e.status === 0 || e.status === 7);
        const inProgress = allWorkOrders.filter(e => e.status === 1 || e.status === 4 || e.status === 5
          || e.status === 6 || e.status === 8 || e.status === 9 || e.status=== 12);
        const completed = allWorkOrders.filter(e => e.status === 2);
        const activeWorkorders = new_wo.concat(inProgress);
        const sortWorkorders = _.orderBy(activeWorkorders, 'report_date', 'desc');
        this.setState({
          workorders: sortWorkorders,
          new_wo: new_wo.length,
          inProgress: inProgress.length,
          completed: completed.length
        });
      }
    }
    if (createWorkorderAction.success === true && prevProps.createWorkorderAction.success === false) {
      this.fetchWorkordersList();
      actionClear();
    }
  }

  fetchWorkordersList = () => {
    const { actionFetchWorkOrders, actionFetchCategories, actionFetchUser } = this.props;
    actionFetchUser();
    const storedRange = localStorage.getItem('lease_maintenance_range');
    const filters = localStorage.getItem('lease_maintenance_filters');
    let s; let f;
    if (storedRange) {
      [s, f] = getDatesFromRange(storedRange);
      s = s.toISOString();
      f = f.toISOString();
    } else {
      s = localStorage.getItem('lease_maintenance_start_date');
      f = localStorage.getItem('lease_maintenance_end_date');
      if (s && f) {
        s = new Date(s);
        f = new Date(f);
      } else {
        s = new Date();
        s.setDate(s.getDate() - 30);
        f = new Date();
        localStorage.setItem('lease_maintenance_range', 'Last 30 days');
      }
      s.setHours(0, 0, 0, 0);
      f.setHours(23, 59, 59, 99);
      s = s.toISOString();
      f = f.toISOString();
    }
    if (filters) {
      this.setState({ filterCategories: filters.split(',') });
      actionFetchWorkOrders(1, undefined, undefined, undefined, filters);
    } else {
      actionFetchWorkOrders(1, s, f);
    }
    actionFetchCategories();
  }

  handleDropdown = () => {
    const { activeTab } = this.state;
    this.setState(prevState => ({ popup: !prevState.popup }));
    if (activeTab === 'open') {
      this.setActiveTab('open');
    } else if (activeTab === 'close') {
      this.setActiveTab('close');
    }
  };

  changePage = (page) => {
    const { actionFetchWorkOrders } = this.props;
    const { range, searchQuery, filterCategories, filter } = this.state;
    this.setState({ currentPage: page });
    if (searchQuery) {
      actionFetchWorkOrders(page, undefined, undefined, searchQuery);
      return;
    }
    if (filterCategories?.length > 0) {
      actionFetchWorkOrders(filter.includes('Created By Me'));
    } else {
      actionFetchWorkOrders(page, range.s, range.f);
    }
  }

  handleQuery = (searchQuery) => {
    const { actionFetchWorkOrders } = this.props;
    this.setState({ searchQuery });
    actionFetchWorkOrders(1, undefined, undefined, searchQuery);
  };

  handleDateChange = (s, f, r) => {
    const { actionFetchWorkOrders } = this.props;
    localStorage.setItem('lease_maintenance_start_date', s);
    localStorage.setItem('lease_maintenance_end_date', f);
    if (r) {
      localStorage.setItem('lease_maintenance_range', r);
    } else {
      localStorage.removeItem('lease_maintenance_range');
    }
    let start_date = new Date(s);
    let end_date = new Date(f);
    start_date.setHours(0, 0, 0, 0);
    end_date.setHours(23, 59, 59, 999);
    start_date = start_date.toISOString();
    end_date = end_date.toISOString();
    this.setState({ range: { s: start_date, f: end_date } });
    actionFetchWorkOrders(1, start_date, end_date);
  }

  handleFiltersList = (filters) => {
    let filterslist = '';
    filters.forEach((item) => {
      filterslist += `${item},`;
    });
    return filterslist;
  }

  handleFiltersPopup = () => {
    const { popup } = this.state;
    const filterCategoriesData = localStorage.getItem('lease_maintenance_filters')
      ? JSON.parse(localStorage.getItem('lease_maintenance_filters'))
      : [];
    this.setState({ popup: !popup, filterCategories: filterCategoriesData });
  }

  updateFilter = (a, b, filter) => {
    const { actionFetchWorkOrders } = this.props;
    this.setState({ filter: [...filter], currentPage: 1 });
    if (filter.length > 0) {
      this.setActiveTab('open');
      actionFetchWorkOrders(filter?.includes('Created By Me'));
      localStorage.setItem('lease_maintenance_filters', JSON.stringify(filter));
    } else {
      localStorage.removeItem('lease_maintenance_filters');
      actionFetchWorkOrders(filter?.includes('Created By Me'));
    }
    this.setState({ popup: false });
  }

  handleRemoveFilter = (val) => {
    const { filter } = this.state;
    const { actionFetchWorkOrders } = this.props;

    const filteredItems = filter.filter(item => item !== val);
    const page = 1;
    this.setState({ currentPage: page });

    if (filteredItems.length > 0) {
      this.setState({
        filter: filteredItems,
        filterCategories: filteredItems
      }, () => {
        this.updateFilter(filteredItems);
      });

      localStorage.setItem('lease_maintenance_filters', JSON.stringify(filteredItems));
    } else {
      this.setState({
        filter: []
      });
      this.setActiveTab('open');
      localStorage.removeItem('lease_maintenance_filters');
      actionFetchWorkOrders();
    }
  };


  handleStatusFilter = (status) => {
    const { actionFetchWorkOrders } = this.props;
    actionFetchWorkOrders(1, undefined, undefined, status, undefined);
    this.setState({ searchQuery: status });
  }

  setActiveTab=(activeTab)=>{
    if (activeTab === 'close') {
      this.displayClosedWorkorders();
    } else {
      this.displayActiveWorkorders();
   }
  this.setState({ activeTab });
  }

  displayActiveWorkorders = () => {
    const { allWorkOrders, user } = this.props;
    if (user?.portal_airport?.airport_settings?.enable_service_request === true) {
      const new_wo = allWorkOrders.filter(e => e.status === 'New' || e.status === 'Duplicate' || e.status === 'Approved');
      const sortWorkorders = _.orderBy(new_wo, 'report_date', 'desc');
      this.setState({ workorders: sortWorkorders });
    } else {
      const new_wo = allWorkOrders.filter(e => e.status === 0 || e.status === 7);
      const inProgress = allWorkOrders.filter(e => e.status === 1 || e.status === 4 || e.status === 5
        || e.status === 6 || e.status === 8 || e.status === 9);
      const activeWorkorders = new_wo.concat(inProgress);
      const sortWorkorders = _.orderBy(activeWorkorders, 'report_date', 'desc');
      this.setState({ workorders: sortWorkorders });
    }
  }

  displayClosedWorkorders = () => {
    const { allWorkOrders, user } = this.props;
    if (user?.portal_airport?.airport_settings?.enable_service_request === true) {
      const completed = allWorkOrders.filter(e => e.status === 'Rejected'
        || e?.status === 'Cancelled'
        || e?.status === 'Closed');
      const sortWorkorders = _.orderBy(completed, 'report_date', 'desc');
      this.setState({ workorders: sortWorkorders });
    } else {
      const completed = allWorkOrders.filter(e => e.status === 2);
      const rejected = allWorkOrders.filter(e => e.status === 3);
      const closedWorkorders = completed.concat(rejected);
      const sortWorkorders = _.orderBy(closedWorkorders, 'report_date', 'desc');
      this.setState({ workorders: sortWorkorders });
    }
  }

  render() {
    const { history, allWorkOrders, user, leaseMaintenance_schema } = this.props;
    const { currentPage, workorders, activeTab, popup, slideStyles, filterCategories, filter } = this.state;
    const maintenanceTitle = user?.portal_airport?.airport_settings?.public_nawo_nomenclature?.length > 0
      ? user?.portal_airport?.airport_settings?.public_nawo_nomenclature : 'Work Orders';
    return (
    <>
      <SectionHeader icon={icon} translationID="topbar.Maintenance_Requests" defaultTitle={maintenanceTitle} values={{ maintenanceTitle }}>
        <div className={styles.detailHeader}>
          <div className={styles.navigation}>
            <Clickable className={activeTab === 'open' ? styles.active:''} onClick={()=>{ this.setActiveTab('open'); }}>
              <FormattedMessage id="maintenance.active" defaultMessage="Active" />
            </Clickable>
            <Clickable className={activeTab === 'close' ? styles.active : ''} onClick={()=>{ this.setActiveTab('close'); }}>
              <FormattedMessage id="maintenance.closed" defaultMessage="Closed" />
            </Clickable>
          </div>
          <Button translationID="maintenance.start.title"
            defaultText="Create"
            onClick={() => history.push('/maintenance/start')}
          />
        </div>
      </SectionHeader>
      <div style={{ display: 'flex' }} className={styles.toolbar}>
        <div className={styles.counter}>
          {activeTab === 'open'
              ?<span className={styles.req}>Active requests</span>
              :<span className={styles.req}>Closed requests</span>
          }
          <span className={styles.number}>{workorders.length}</span>
        </div>
        <div className={styles1.toolbar}>
        <Clickable className={`${styles1.actionsBtn1} ${styles1.formActionBtn}`} onClick={() => this.handleDropdown()}>
          <FormattedMessage id="workorders.list.filters" defaultMessage="Filters " />
        </Clickable>
        </div>
      </div>
      <div className={styles2.filter} style={{ background: 'none' }}>
        {filter?.map(category => (
          <span className={styles2.user} key={category}>
            {category}
            <span
              onKeyPress={() => this.handleRemoveFilter(category)}
              tabIndex={0}
              role="button"
              onClick={() => this.handleRemoveFilter(category)}
              className={styles2.btnRemove}
            />
          </span>
        ))}
      </div>
      <div className={styles.container}>
        { allWorkOrders && workorders && (
        <Table info={workorders} schema={leaseMaintenance_schema?.workorder || {}} />
        )}
        {allWorkOrders && workorders && Object.keys(workorders).length > 0
            && (
              <Paginator
                page={currentPage}
                totalRecords={allWorkOrders.count}
                pageLimit={20}
                pageNeighbours={1}
                onPageChanged={page => this.changePage(page)}
              />
            )
          }
          {popup && (
          <Transition in={popup} timeout={200} unmountOnExit>
            <FilterForm
              transition={slideStyles}
              update={this.updateFilter}
              cancel={this.handleDropdown}
              selectedFiltersValue={filter}
              filter_Categories={filterCategories}
              setActiveTab={this.setActiveTab}
              filterStyle
            />
          </Transition>
          )}
      </div>
    </>
    );
  }
}

MaintenanceList.propTypes = {
  actionFetchWorkOrders: PropTypes.func.isRequired,
  actionFetchCategories: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  leaseMaintenance_schema: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapStateToProps = state => ({
  user: state.auth.profile,
  allWorkOrders: state.lease.allWorkOrders,
  allCategories: state.lease.allCategories,
  createWorkorderAction: state.lease.createWorkorderAction,
  leaseMaintenance_schema: state.lease.leaseMaintenance_schema
});

const mapDispatchToProps = dispatch => ({
  actionFetchWorkOrders: (filter) => {
    dispatch(fetchLeaseWorkorders(filter));
  },
  actionFetchCategories: () => {
    dispatch(fetchCategories());
  },
  actionFetchUser: () => {
    dispatch(fetchUserProfile());
  },
  actionClear: () => {
    dispatch(clearCreateAction());
  },
  actionFetchSchema: () => {
    dispatch(fetchWorkOrderSchema());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceList);
